export default __webpack_public_path__ + "static/pre_employment-c6222116f505258012e3e876c2cd0557.png";